export default __webpack_public_path__ + "static/media/PrintWHT.e86dc508.svg";